module.exports = __webpack_public_path__ + "media/images/proof_links/proof_green/facebook_big-1056a78351f846888dd92cd0723eeb18.svg";